module.exports = __webpack_public_path__ + "img/ufo.171af53f.svg";